import { render, staticRenderFns } from "./ModalProductLabelSearch.vue?vue&type=template&id=10aa73c7&scoped=true&"
import script from "./ModalProductLabelSearch.vue?vue&type=script&lang=js&"
export * from "./ModalProductLabelSearch.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductLabelSearch.vue?vue&type=style&index=0&id=10aa73c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa73c7",
  null
  
)

export default component.exports